// For custom Js that will render accross entire site
// Header
(function () {
    function initHeaderMenu() {
        let headerNavButtons = document.querySelectorAll('.header__link-button');

        headerNavButtons.forEach((button, index) => {
            // Get submenu wrapper
            let submenu = button.closest('.header__desktop-menu-li').querySelector('.submenu');

            if (submenu) {
                // Ensure submenu has an ID (auto-generate if missing)
                if (!submenu.id) {
                    submenu.id = `submenu-${index + 1}`;
                }
                // Link aria-controls
                button.setAttribute('aria-controls', submenu.id);
            }

            // Initialize aria-expanded
            button.setAttribute('aria-expanded', 'false');

            button.addEventListener('click', () => {
                let isActive = button.classList.contains('active');

                // Close all first
                headerNavButtons.forEach(item => {
                    item.classList.remove('active');
                    item.setAttribute('aria-expanded', 'false');
                    item.closest('.header__desktop-menu-li').classList.remove('open');
                });

                // Toggle this one
                if (!isActive) {
                    button.classList.add('active');
                    button.setAttribute('aria-expanded', 'true');
                    button.closest('.header__desktop-menu-li').classList.add('open');
                }
            });
        });
    }

    function closeDesktopMenuonFocusOut() {
        function closeMenus() {
            let headerNavButtons = document.querySelectorAll('.header__link-button');
            headerNavButtons.forEach(item => {
                item.classList.remove('active');
                item.setAttribute('aria-expanded', 'false');
                item.closest('.header__desktop-menu-li').classList.remove('open');
            });
        }

        document.addEventListener('click', function (event) {
            let elem = document.querySelector('.header__desktop-menu-li.open');
            if (!elem) return;
            if (!elem.contains(event.target)) closeMenus();
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') closeMenus();
        });
    }

    closeDesktopMenuonFocusOut();
    initHeaderMenu();
})();


// accordions
(function(){
    function initAccordions(){
        const accordions = document.querySelectorAll('.accordion-wrapper');
        accordions.forEach(accordion =>{
            accordion.addEventListener('click',()=>{
                accordion.classList.toggle('open');
            })
        })
    }

    initAccordions()
})();